import React from 'react'
import NotificationCoverModel from '../../../../NotificationCoverModel'
import i18next from 'i18next'

const DepContribRemovalNotifCover = ({ notification }) => {
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <NotificationCoverModel
      notification={notification}
      notifCoverContent={
        rtl
          ? `لقد تم إزالتك من القسم الخاص بك`
          : 'You have been removed from your department'
      }
    />
  )
}

export default DepContribRemovalNotifCover
